
let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
  {
    id: 1,
    title: 'All-day event',
    start: todayStr,
    backgroundColor: '#378006',
    color: '#ffffff',
  },
  {
    id: 2,
    title: 'Timed event',
    start: todayStr + 'T12:00:00'
  }
]

/*
*  events: [
    {
      title: 'BCH237',
      start: '2019-08-12T10:30:00',
      end: '2019-08-12T11:30:00',
      extendedProps: {
        department: 'BioChemistry'
      },
      description: 'Lecture'
    }
    // more events ...
  ],
*
* */

export function createEventId() {
  return String(eventGuid++)
}
